/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { useStyles } from './styles';

interface IFormDialogProps {
  children: React.ReactNode;
  handleClose: Function;
  dialogTitle: React.ReactNode;
  dialogAction1: React.ReactNode;
  dialogAction2: React.ReactNode;
  dialogLoader?: React.ReactNode;
  openModal: boolean;
  maxWidth?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | undefined;
  className?: string;
};

const FormDialog = ({
  children,
  dialogTitle,
  dialogAction1,
  dialogAction2,
  dialogLoader,
  openModal,
  maxWidth,
  className = ''
}: IFormDialogProps) => {
  const { classes } = useStyles();
  return (
    <Dialog
      id="form-dialog"
      open={openModal}
      fullWidth
      maxWidth={maxWidth || 'md'}
      className={`${classes.formDialogPaper} ${className}`}
    >
      <DialogTitle id="form-dialog-title">{dialogTitle}</DialogTitle>
      <DialogContent id="form-dialog-content">{children}</DialogContent>
      <DialogActions>
        {dialogLoader}
        {dialogAction1}
        {dialogAction2}
      </DialogActions>
    </Dialog>
  );
};

export default FormDialog;
